import "./style.scss";
import { useState } from "react";
import CloseSvg from "@/src/svg/CustomUtils/CloseSvg";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";

export type CommentItem = {
  date: string;
  logo: React.ComponentType;
  description: string;
};

type Props = {
  onClose: () => void;
  comments: CommentItem[];
  title: string;
};

const CustomComments = ({ onClose, comments, title }: Props) => {
  const [noteValue, setNoteValue] = useState<string>("");
  const [actualComments, setactualComments] = useState<CommentItem[]>(comments);

  const getTodayDate = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const handleClear = () => {
    setNoteValue("");
  };

  const handleDone = () => {
    if (noteValue.trim()) {
      const logo = actualComments[0]?.logo;
      if (logo) {
        const newComment: CommentItem = {
          date: getTodayDate(),
          logo,
          description: noteValue.trim(),
        };
        setactualComments((prev) => [newComment, ...prev]);
      }
      setNoteValue("");
    }
    // onClose();
  };

  return (
    <div className="custom-comments">
      <div className="custom-comments-title">
        <div className="custom-comments-title-text">
          <p>{title}</p>
        </div>
        <div className="custom-comments-title-close" onClick={onClose}>
          <CloseSvg />
        </div>
      </div>
      <div className="custom-comments-list">
        {actualComments.map((item, index) => (
          <div className="custom-comments-list-item" key={index}>
            <div className="custom-comments-list-item-header">
              <p>{item.date}</p>
              <item.logo />
            </div>
            <div className="custom-comments-list-item-body">
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="custom-comments-note">
        <textarea placeholder="Note..." value={noteValue} onChange={(e) => setNoteValue(e.target.value)} />
      </div>
      <div className="custom-comments-buttons">
        <BtnDefault onClick={handleClear}>
          <p>Clear</p>
        </BtnDefault>
        <BtnDefault onClick={handleDone}>
          <p>Done</p>
        </BtnDefault>
      </div>
    </div>
  );
};

export default CustomComments;
